import React from "react";

const FooterTiktokIcon = (): JSX.Element => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 319.81 319.81"
  >
    <defs>
      <clipPath id="clip-path-5a" transform="translate(-160.55 -138.84)">
        <circle className="cls-1 a" fill="none" cx="320.45" cy="298.74" r="145.37" />
      </clipPath>
      <clipPath id="clip-path-5b" transform="translate(-160.55 -138.84)">
        <path
          className="cls-2" fill="none" clip-rule="evenodd"
          d="M365.49,197c3.49,29.91,20.27,47.74,49.45,49.64v33.64C398,281.91,383.22,276.41,366,266V329c0,79.93-87.6,104.91-122.81,47.62C220.54,339.71,234.4,275,307,272.43v35.48A104.51,104.51,0,0,0,290.15,312c-16.14,5.43-25.3,15.62-22.75,33.57,4.89,34.41,68.33,44.59,63.06-22.63V197.05h35Z"
        />
      </clipPath>
    </defs>
    <g className="cls-3" clip-path="url(#clip-path-5a)">
      <rect width="319.81" height="319.81" />
    </g>
    <g className="cls-4" clip-path="url(#clip-path-5b)">
      <rect fill="#fff" x="45.46" y="43.61" width="223.47" height="265.96" />
    </g>
  </svg>
);

export default FooterTiktokIcon;
